import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';

import { ProductDetailsContext } from '../context';
import { messages } from '../messages';

import style from '../style.module.less';

export const ProductDetailsDimensionsPresetGroupDisplay = () => {
  const { currentProductProfile, parentProduct } = useContext(ProductDetailsContext);

  const inheritedValues = {
    convertedLength: currentProductProfile.convertedLength || parentProduct.convertedLength,
    lengthMessage: currentProductProfile.convertedLength ? messages.presetGroupInfo : messages.parentInfo,
    convertedWidth: currentProductProfile.convertedWidth || parentProduct.convertedWidth,
    widthMessage: currentProductProfile.convertedWidth ? messages.presetGroupInfo : messages.parentInfo,
    convertedHeight: currentProductProfile.convertedHeight || parentProduct.convertedHeight,
    heightMessage: currentProductProfile.convertedHeight ? messages.presetGroupInfo : messages.parentInfo,
  };

  const { convertedLength, lengthMessage, convertedWidth, widthMessage, convertedHeight, heightMessage } = inheritedValues;

  return (
    <div className={style['profile-info']}>
      {!!convertedLength && (
        <div>
          <FormattedMessage {...lengthMessage} />
          &nbsp;L: {convertedLength}
        </div>
      )}
      {!!convertedWidth && (
        <div>
          <FormattedMessage {...widthMessage} />
          &nbsp;W: {convertedWidth}
        </div>
      )}
      {!!convertedHeight && (
        <div>
          <FormattedMessage {...heightMessage} />
          &nbsp;H: {convertedHeight}
        </div>
      )}
    </div>
  );
};
